import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "../i18n";
import { PRODUCTS, productHref } from "../data/products";
import { Reveal, Eyebrow } from "../components/Reveal";
import { imgProps } from "../lib/api";

export default function Products() {
  const { t, lang } = useLang();
  return (
    <div data-testid="products-page" className="pt-32 sm:pt-40 pb-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <Eyebrow>{t.products_eyebrow}</Eyebrow>
          <h1 className="mt-4 max-w-3xl font-serif text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight leading-[1.05] text-[#F3EFE6]">{t.products_title}</h1>
          <p className="mt-6 max-w-xl text-sm sm:text-base font-light text-[#A39E93] leading-relaxed">{t.products_sub}</p>
        </Reveal>

        <div className="mt-16 flex flex-col">
          {PRODUCTS.map((p, i) => (
            <Reveal key={p.slug} delay={i * 0.05}>
              <Link to={productHref(p)} data-testid={`product-row-${p.slug}`} className="group grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 items-center border-t border-[#1C1A17] py-10 sm:py-14 transition-colors duration-500 hover:bg-[#0F0F0E]">
                <span className="md:col-span-1 font-mono text-sm tracking-[0.3em] text-[#C8A86B]">{p.number}</span>
                <div className="md:col-span-4 aspect-[4/3] overflow-hidden border border-[#262420] bg-[#111110]">
                  <img {...imgProps(p.image, "(max-width: 768px) 100vw, 33vw")} alt={lang === "it" ? p.name_it : p.name_en} loading="lazy" className="h-full w-full object-cover transition-all [transition-duration:1400ms] ease-out group-hover:scale-105 group-hover:brightness-110" />
                </div>
                <div className="md:col-span-6">
                  <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-[#F3EFE6] transition-colors duration-300 group-hover:text-[#D8BD85]">{lang === "it" ? p.name_it : p.name_en}</h2>
                  <p className="mt-3 text-sm sm:text-base font-light text-[#A39E93] leading-relaxed">{lang === "it" ? p.tagline_it : p.tagline_en}</p>
                  <p className="mt-5 hidden sm:block text-sm font-light text-[#827D72] leading-relaxed line-clamp-2">{lang === "it" ? p.intro_it : p.intro_en}</p>
                </div>
                <span className="md:col-span-1 flex h-12 w-12 items-center justify-center rounded-full border border-[#C8A86B]/40 text-[#C8A86B] transition-all duration-500 group-hover:bg-[#C8A86B] group-hover:text-[#080808] group-hover:rotate-45"><ArrowUpRight size={18} /></span>
              </Link>
            </Reveal>
          ))}
          <div className="border-t border-[#1C1A17]" />
        </div>
      </div>
    </div>
  );
}
